import React from 'react';
import { Award, Users, Home, ShieldCheck } from 'lucide-react';
import ScrollReveal from './ScrollReveal';
import AnimatedCounter from './AnimatedCounter';

const stats = [
  { icon: Award, target: 5, suffix: '+', label: 'Años de experiencia' },
  { icon: Home, target: 60, suffix: '+', label: 'Propiedades comercializadas' },
  { icon: Users, target: 75, suffix: '+', label: 'Clientes satisfechos' },
  { icon: ShieldCheck, target: 100, suffix: '%', label: 'Compromiso y transparencia' }
];

const AboutUs = () => {
  return (
    <section id="nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Sobre Sanz Berger
          </h2>
          <p className="text-muted-foreground text-lg">
            En Sanz Berger Bienes Raíces brindamos asesoramiento personalizado para la compra, venta,
            alquiler y tasación de propiedades en la provincia de Salta, acompañando a cada cliente
            con compromiso, confianza y profesionalismo.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <ScrollReveal key={stat.label} delay={index * 100} className="text-center">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4">
                <stat.icon className="w-7 h-7 text-primary" />
              </div>
              <p className="text-3xl font-bold text-foreground">
                <AnimatedCounter target={stat.target} suffix={stat.suffix} />
              </p>
              <p className="text-sm text-muted-foreground mt-1">{stat.label}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
